import PropTypes from 'prop-types';

import FeedFloButton from '../../atoms/FeedFloButton';
import MessageHistoryTableRow from './MessageHistoryTableRow';
import './MessageHistoryTable.scss';

function MessageHistoryTable({
  rows = [],
  loading = false,
  pageNum = 0,
  maxRows = 50,
  itemTotalCount = 0,
  onClickNext = () => {},
  onClickPrevious = () => {},
}) {
  const prevButtonEnabled = pageNum > 0;
  const nextButtonEnabled = (pageNum + 1) * maxRows < itemTotalCount;
  const empty = rows.length === 0;
  const pageCount = Math.max(1, Math.ceil(itemTotalCount / maxRows));

  const renderBody = () => {
    if (loading) {
      return Array(maxRows > 8 ? 8 : maxRows)
        .fill(0)
        .map((_, index) => (
          <div key={`loading-${index}`} className="MessageHistoryTable-row MessageHistoryTable-row--loading">
            <div className="MessageHistoryTable-skeleton MessageHistoryTable-skeleton--mode" />
            <div className="MessageHistoryTable-skeleton MessageHistoryTable-skeleton--status" />
            <div className="MessageHistoryTable-skeletonGroup">
              <div className="MessageHistoryTable-skeleton MessageHistoryTable-skeleton--short" />
              <div className="MessageHistoryTable-skeleton MessageHistoryTable-skeleton--shorter" />
            </div>
            <div className="MessageHistoryTable-skeleton MessageHistoryTable-skeleton--medium" />
            <div className="MessageHistoryTable-skeleton MessageHistoryTable-skeleton--long" />
          </div>
        ));
    }

    if (empty) {
      return <div className="MessageHistoryTable-empty">No messages match the current filters.</div>;
    }

    return rows.map((row) => (
      <MessageHistoryTableRow
        key={row.id}
        messageId={row.id}
        date={row.date}
        time={row.time}
        userId={row.userId}
        userName={row.userName}
        organizationId={row.organizationId}
        transportedAs={row.transportedAs}
        status={row.status}
        entries={row.entries}
      />
    ));
  };

  return (
    <div className="MessageHistoryTable">
      <MessageHistoryTableRow isHeader />
      {renderBody()}
      <div className="MessageHistoryTable-footer">
        <div className="MessageHistoryTable-results">
          <b>{!loading ? <span>{itemTotalCount}</span> : <span>…</span>}</b> results
        </div>
        <div className="MessageHistoryTable-pageNumber noselect">
          {`Page ${pageNum + 1} of ${!loading ? pageCount : '…'}`}
        </div>
        <div className="MessageHistoryTable-footerButtons">
          <FeedFloButton
            onClick={prevButtonEnabled ? onClickPrevious : null}
            disabled={empty || !prevButtonEnabled}
          >
            Previous
          </FeedFloButton>
          <FeedFloButton onClick={nextButtonEnabled ? onClickNext : null} disabled={empty || !nextButtonEnabled}>
            Next
          </FeedFloButton>
        </div>
      </div>
    </div>
  );
}

MessageHistoryTable.propTypes = {
  rows: PropTypes.array,
  loading: PropTypes.bool,
  pageNum: PropTypes.number,
  maxRows: PropTypes.number,
  itemTotalCount: PropTypes.number,
  onClickNext: PropTypes.func,
  onClickPrevious: PropTypes.func,
};

export default MessageHistoryTable;
